import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { AihobsEcsChangePasswordSentComponent } from './aihobs-ecs-change-password-sent/aihobs-ecs-change-password-sent.component';
import { AihobsEcsForgotPasswordComponent } from './aihobs-ecs-forgot-password/aihobs-ecs-forgot-password.component';
import { AihobsEcsInputComponent } from './aihobs-ecs-input/aihobs-ecs-input.component';
import { AihobsEcsLoginComponent } from './aihobs-ecs-login/aihobs-ecs-login.component';
import { AihobsEcsPasswordInputComponent } from './aihobs-ecs-password-input/aihobs-ecs-password-input.component';
import { AihobsEcsRegisterResendComponent } from './aihobs-ecs-register-resend/aihobs-ecs-register-resend.component';
import { AihobsEcsRegisterSendComponent } from './aihobs-ecs-register-send/aihobs-ecs-register-send.component';
import { AihobsEcsRegisterComponent } from './aihobs-ecs-register/aihobs-ecs-register.component';
import { AihobsEcsResetPasswordComponent } from './aihobs-ecs-reset-password/aihobs-ecs-reset-password.component';
import { AihobsEcsUnblockComponent } from './aihobs-ecs-unblock/aihobs-ecs-unblock.component';
import { AihobsEcsComponent } from './aihobs-ecs/aihobs-ecs.component';
import { OemService } from './oem.service';

@NgModule({
  declarations: [
    AihobsEcsComponent,
    AihobsEcsLoginComponent,
    AihobsEcsRegisterComponent,
    AihobsEcsUnblockComponent,
    AihobsEcsRegisterResendComponent,
    AihobsEcsRegisterSendComponent,
    AihobsEcsForgotPasswordComponent,
    AihobsEcsResetPasswordComponent,
    AihobsEcsChangePasswordSentComponent,
    AihobsEcsInputComponent,
    AihobsEcsPasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    AihobsEcsResetPasswordComponent,
    AihobsEcsComponent,
    AihobsEcsRegisterResendComponent,
    AihobsEcsRegisterSendComponent,
    AihobsEcsUnblockComponent,
    AihobsEcsChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AihobsEcsModule {}
